import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import moment from 'moment';
import { goToUrl } from '../Table/tableActions';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const CHARGEBACKS_LOAD = 'CHARGEBACKS/CHARGEBACKS_LOAD';
export const CHARGEBACKS_SUCCESS = 'CHARGEBACKS/CHARGEBACKS_SUCCESS';
export const CHARGEBACKS_FAILURE = 'CHARGEBACKS/CHARGEBACKS_FAILURE';
export const CHARGEBACKS_SUMMARY_FAILURE = 'CHARGEBACKS/CHARGEBACKS_SUMMARY_FAILURE';
export const CHARGEBACKS_SUMMARY_LOAD = 'CHARGEBACKS/CHARGEBACKS_SUMMARY_LOAD';
export const CHARGEBACKS_SUMMARY_SUCCESS = 'CHARGEBACKS/CHARGEBACKS_SUMMARY_SUCCESS';

export const fetchUrl = `${config.chargebackApiUrl}`;

export function getChargebacks(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getChargebacksFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: CHARGEBACKS_LOAD,
        successActionTypeOrCreator: getChargebacksSuccessActionCreator
    };
}

export function getChargebacksSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, CHARGEBACKS_SUCCESS, 'chargebacks');
}

export function getChargebacksFailureActionCreator(error) {
    return {
        error,
        type: CHARGEBACKS_FAILURE
    };
}

export function getChargebacksSummary(merchantIds) {
    const filters = [{
        id: 'reportDate',
        value: {
            startDate: moment().utc().subtract(14, 'day').startOf('day'),
            endDate: moment().utc().endOf('day')
        }
    }];

    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters,
        merchantIds
    });

    return {
        failureActionTypeOrCreator: getChargebacksSummaryFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/summary${queryParamsString}`
        },
        loadActionTypeOrCreator: CHARGEBACKS_SUMMARY_LOAD,
        successActionTypeOrCreator: getChargebacksSummarySuccessActionCreator
    };
}

export function getChargebacksSummarySuccessActionCreator(summary) {
    return {
        summary: summary,
        type: CHARGEBACKS_SUMMARY_SUCCESS
    };
}

export function getChargebacksSummaryFailureActionCreator(error) {
    return {
        error,
        type: CHARGEBACKS_SUMMARY_FAILURE
    };
}

export function goToChargebackTable(achDetailId, history) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters: [{
            id: 'achDetailsId',
            value: achDetailId
        }],
        page: 0,
        pageSize: 10,
        sorters: []
    });
    history.push(`/chargeback${queryParamsString}`);
}

export function goToChargeback(history, chargeback = {}, newTab) {
    goToUrl(history, `/chargeback/${chargeback.id}`, newTab);
}

export function getChargebackTableLink(achDetailId, startDate) {
    const calculatedEndDate = moment().isBefore(moment(startDate).add(1, 'month'))
        ? moment().format('YYYY-MM-DD')
        : moment(startDate).add(1, 'month').format('YYYY-MM-DD');
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters: [{
            id: 'achDetailsId',
            value: achDetailId
        },
        {
            id: 'startDate',
            value: moment(startDate).subtract(1, 'month').format('YYYY-MM-DD')
        },
        {
            id: 'endDate',
            value: calculatedEndDate
        }],
        page: 0,
        pageSize: 10,
        sorters: []
    });

    return `/chargeback${queryParamsString}`;
}

export function getChargebackLink(chargeback = {}) {
    return `/chargeback/${chargeback.id}`;
}
